import { ReactNode } from "react";
import style from "./Header.module.scss";

export type HeaderProps = {
  /** Contenu de gauche : logo ou titre d'application, éventuellement un sous-titre. */
  left?: ReactNode;
  /** Contenu de droite : actions (aide, menu utilisateur…). */
  right?: ReactNode;
};

/**
 * Barre d'en-tête pleine largeur (layout uniquement). Le contenu — logo, titre,
 * actions — est fourni par l'application via les slots `left` et `right`.
 */
export function Header({ left, right }: HeaderProps) {
  return (
    <div className={style.header}>
      <div className={style.headerLeft}>{left}</div>
      {right && <div className={style.headerRight}>{right}</div>}
    </div>
  );
}
